// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.schedule.ScheduleViewPreferencesResponse */
/* istanbul ignore next */
@GandalfModel
export class ScheduleViewPreferencesResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	enableGroupingPreference!: boolean | null;

	@GandalfConstantDecorator(constants.ScheduleIncrementPreferenceValues)
	@GandalfProperty({ designType: constants.ScheduleIncrementPreferenceValues })
	incrementPreference!: constants.ScheduleIncrementPreferenceValues | null;

	@GandalfConstantDecorator(constants.ScheduleLayoutPreferenceValues)
	@GandalfProperty({ designType: constants.ScheduleLayoutPreferenceValues })
	layoutPreference!: constants.ScheduleLayoutPreferenceValues | null;

	@GandalfConstantDecorator(constants.ScheduleView)
	@GandalfProperty({ designType: constants.ScheduleView })
	scheduleView!: constants.ScheduleView | null;

}
